const styles = {
  deletedTag: {
    display: "inline-block",
    backgroundColor: "#fff1f0",
    border: "1px solid #ffa39e",
    borderRadius: "4px",
    padding: "0 0.7vw",
    fontSize: "1.5vw",
    fontWeight: "bold",
    lineHeight: "1.5",
    color: "#cf1322",
    marginTop: "0.5vw",
  },
};

export default function DeletedTag() {
  return <span style={styles.deletedTag}>Deleted</span>;
}
